<template>
  <ResponseContainer>
    <div v-if="admin" class="relative -left-[50%]">
      <table>
        <thead>
          <tr>
            <th>Group</th>
            <th>Name</th>
            <th>RSVP</th>
            <th>Dietary</th>
            <th>Updated</th>
          </tr>
        </thead>
        <tbody>
          <!-- eslint-disable -->
          <template v-for="p in parties" :key="p">
            <tr v-for="(g, i) in p.members" :key="g">
              <td v-if="!i" :id="p.id" :rowspan="p.members.length + (p.additional ? 1 : 0)" @mouseover="showRsvped(p.id)" @mouseleave="hideRsvped(p.id)">
                <div>
                  <div>{{ p.name }}</div>
                  <div>({{ p.code }})</div>
                </div>
                <div :class="{ 'hidden': active }">{{ p.rsvped ? '✅' : '' }}</div>
                <div :class="{ 'hidden': !active }">{{ p.rsvped.toLocaleString() }}</div>
              </td>
              <td>{{ g.name }}</td>
              <td>{{ g.rsvp }}</td>
              <td>{{ g.dietary }}</td>
              <td>{{ g.updated.toLocaleString() }}</td>
            </tr>
            <tr v-if="p.additional">
              <td>Optional +1</td>
              <td>null</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
          <!-- eslint-enable -->
        </tbody>
      </table>
    </div>
    <button @click="$router.push('/admin')" class="mt-8">← Back</button>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Group from '@/models/group'
import Cookie from '@/helpers/cookie'

export default {
  name: 'AdminGuestsPage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
      admin: false,
      parties: [],
      active: false,
    }
  },
  beforeMount() {
    this.autoSecret()
    this.loadParties()
  },
  methods: {
    async loadParties() {
      this.parties = await Group.getAll()
    },
    autoSecret() {
      const secret = Cookie.get('admin')
      if (secret === process.env.VUE_APP_ADMIN_SECRET) {
        this.admin = true
      } else {
        this.$router.push('/admin')
      }
    },
    showRsvped() {
      this.active = true
    },
    hideRsvped() {
      this.active = false
    },
  },
}
</script>